export default {"src":"/_next/static/media/pol.119fdc01.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};